import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { InitialStateInterface } from './types';
import type { IPlaceMinimal } from '@/hooks/place/usePlacesMinimal';

const initialState: InitialStateInterface = {
  placesMinimal: [],
};

const utilSlice = createSlice({
  name: 'utils',
  initialState,
  reducers: {
    setPlacesMinimal: (
      state,
      action: PayloadAction<{ places: IPlaceMinimal[] }>,
    ) => {
      state.placesMinimal = action.payload.places;
    },
  },
});

export const { setPlacesMinimal } = utilSlice.actions;

export const utilReducer = utilSlice.reducer;
